import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import type { IStyler } from '@alfa-bank/site-util-create-widget/src/models';
import React, { useMemo } from 'react';

import { Block as Component } from '../block';
import type { IDeps, IProps, TBlock } from '../models';
import styles from '../styles/desktop.css';

export const BlockDesktop = ({ borderRadius, inner, styler, ...rest }: IProps) => {
    const customStyler: IStyler = {};

    if (typeof borderRadius !== 'undefined' && borderRadius !== false) {
        // Для обратной совместимости, когда borderRadius был true/false, и в случае true был равен 4px
        customStyler.borderRadius = borderRadius === true ? 4 : borderRadius;
    }

    if (inner) {
        customStyler.borderRadius = 4;
        customStyler.paddingLeft = 0;
        customStyler.paddingRight = 0;
        customStyler.paddingTop = 24;
        customStyler.paddingBottom = 24;
    }

    const Comp = useMemo(
        () => createWidget<IDeps, TBlock>({ styles }, { priorityStyler: true })(Component),
        []
    );

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <Comp styler={{ ...customStyler, ...styler }} {...rest} />;
};
